import axios from 'axios'

export default {
    namespaced: true,

    state: {
        lineSubjectChosen: {},
        application: {},
    },

    getters: {
       getLineSubjectChosen(state){
           return state.lineSubjectChosen
       },

       getApplication(state){
           return state.application
       },    
    },

    mutations: {
        setLineSubjectChosen(state, payload){
            state.lineSubjectChosen = payload
        },

        setApplication(state, payload){
            state.application = payload
        }
    },

    actions: {
        getCsecSubjectSelectionLines(){
            const url = '/api/csec-subject-selection-lines';
            return axios.get(url);
        },

        postSubjectSelectionLine({ getters}){
            const url = '/api/csec-subject-choice';
            return axios.post(url, getters.getLineSubjectChosen);
        },

        getSubjectChoice({ getters }){
            const url = '/api/csec-subject-choice';
            return axios.get(url, {
                params: {
                    student_id: getters.getApplication.student_id
                }
            });
        },

        postApplication({ getters }){
            const url = '/api/csec-subject-selection-application';
            return axios.post(url, getters.getApplication);
        },

        getApplication({ getters}){
            const url = '/api/csec-subject-selection-application';
            return axios.get(url, {
                params: {
                    student_id: getters.getApplication.student_id
                }
            });
        }
       
    }
}